import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './landing.css';
import BG from '../images/dali-clocks.jpg';

export function Landing() {

  return (
    <div className='background' style={{backgroundImage: `url(${BG})`}}>
      {/* <h1 style={{ marginTop: '10%', color: '#6368c9' }}>Welcome!</h1> */}
      <Link to='/join'>
        <button className='button-1' style={{ backgroundColor: '#63bdc9' }}>Join Session</button>
      </Link>
      <Link to='/create'>
        <button className='button-1' style={{ backgroundColor: '#63c96c' }}>Create Session</button>
      </Link>
      <Link to='/saved'>
        <button className='button-1' style={{ backgroundColor: '#a8325c' }}>Saved Watches</button>
      </Link>
    </div>
  )
}